import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToplineService } from '../../service/topline.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-topline-alias',
  templateUrl: './topline-alias.component.html',
  styleUrls: ['./topline-alias.component.scss']
})
export class ToplineAliasComponent implements OnInit, OnDestroy {
  public searchText:string = "";
  constructor(
    public toplineService:ToplineService,
    public location:Location,
    private aRout:ActivatedRoute
  ) { this.aRout.params.subscribe(param => {
    this.toplineService.setCrosstabFileUUID(param['uuid']);
  })}

  ngOnDestroy(): void {
    this.searchText = "";
    this.toplineService.searchText = "";
    this.toplineService.setCrosstabFileUUID("")
    this.toplineService.listItems = {};
    this.toplineService.linearDataList = {};
    this.toplineService.listTypes = {};
  }

  ngOnInit(): void {
    this.toplineService.listItems;
    this.toplineService.activeTab = 'tables';
    this.toplineService.switchTabs(this.toplineService.activeTab);
  }

  onSearchChange(text){
    this.searchText = text;
    this.toplineService.searchText = text;
    this.toplineService.getList();
  }

  next(){
    this.toplineService.activeTab == 'tables' ? this.toplineService.switchTabs('side cuts') : this.toplineService.activeTab == 'side cuts'  ? this.toplineService.switchTabs('top cuts') : this.toplineService.switchTabs('top cuts')
  }

  saveAndNext(){
    this.toplineService.aliasArrToJsonConverter();
  }


  goBackToplineSheet(){
    this.location.back();
  }

}
